import { GetActivityLogListResponse } from "@/app/api/activity-log/route";
import { getActivityLogListRequestSchema } from "@/lib/schemas/activity-log";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const ACTIVITY_LOG_ENDPOINT = "/api/activity-log";

export const invalidateActivityLogQuery = createInvalidateQuery(
  ACTIVITY_LOG_ENDPOINT,
);

export const useActivityLogListQuery =
  createQueryHook<GetActivityLogListResponse>(
    ACTIVITY_LOG_ENDPOINT,
    getActivityLogListRequestSchema,
  );
